import React from 'react';
import ProducersAllProduct from "../components/ProducersAllProduct";



const ProducersPage = () => {
    return (
        <React.Fragment>
            <ProducersAllProduct />
        </React.Fragment>
    );
};

export default ProducersPage;

